export const config = {
  MapboxPublicKey: 'pk.eyJ1IjoiYmFsa2VybmUiLCJhIjoiY2wwdGswNDhpMDAzczNrbXY1aHE3dno5OSJ9.gmUFneco76pHw2FmprGpPw',
  GoogleMapsKey: "AIzaSyCPOQgTIkGiKuleo1CDM79DA2AqiY83AV4",
  BackendEndpointStatic: 'https://api.balkerne.com/prod',
}
